/**
 * Alpine.js Profile Hero Photo Carousel
 *
 * Scroll-snap carousel for the mobile profile hero card. Native horizontal
 * scrolling provides the swipe gesture and tap-vs-drag disambiguation; this
 * component only derives the current slide index from the scroll position
 * so the position dots can highlight it.
 */
export function profileHeroCarousel(config = {}) {
    return {
        photoCount: config.photoCount || 1,
        currentIndex: 0,

        init() {
            // Sync with a browser-restored scroll position (reload, history nav).
            this.$nextTick(() => this.onScroll());
            this._onResize = () => this.onScroll();
            window.addEventListener('resize', this._onResize);
        },

        destroy() {
            window.removeEventListener('resize', this._onResize);
        },

        onScroll() {
            const track = this.$refs.track;
            if (!track || track.clientWidth === 0) return;
            // In RTL documents scrollLeft is 0 at the start edge and grows
            // negative, so use the absolute offset for the slide index.
            const index = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
            this.currentIndex = Math.max(0, Math.min(this.photoCount - 1, index));
        }
    };
}
